import script from "./EmailTrocaNivel.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailTrocaNivel.vue?vue&type=script&setup=true&lang=js"

import "./EmailTrocaNivel.vue?vue&type=style&index=0&id=852d1a00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-852d1a00"]])

export default __exports__